var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"StatisticalGraph"},[_c('div',{staticStyle:{"width":"100%","height":"200px"},attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }